import React, { useState, useEffect } from "react";
import { Modal, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBriefcase,
    faLocationDot,
    faClock,
    faGraduationCap,
    faPen,
    faPlus,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import "./clientJobListings.css"
import JobListingService from "../../../services/JobListingService";
import JobFormModal from "./jobFormModal";
import { MasterDataService } from "../../../services/masterDataService";
const ClientJobListings = () => {
    const [loading, setLoading] = useState(false);
    const [cities, setCities] = useState([]);
    const [ugDegrees, setUgDegrees] = useState([]);
    const [pgDegrees, setPgDegrees] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [industrySubcategories, setIndustrySubcategories] = useState([]);

    const [functions, setFunctions] = useState([]);
    const [functionSubcategories, setFunctionSubcategories] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [hasNext, setHasNext] = useState(false);
    const jobsPerPage = 6;

    const [currentPage, setCurrentPage] = useState(0);

    const [activeTab, setActiveTab] = useState("ACTIVE");

    const [activeJobsCount, setActiveJobsCount] = useState(0);
    const [closedJobsCount, setClosedJobsCount] = useState(0);

    const [showPostJobModal, setShowPostJobModal] = useState(false);
    const [doctorateInput, setDoctorateInput] = useState("");
    const [editDoctorateInput, setEditDoctorateInput] = useState("");
    const [jobForm, setJobForm] = useState({
        title: "",
        industry: "",
        industryId: "",
        industrySubcategory: "",
        location: "",
        function: "",
        functionId: "",
        functionSubcategory: "",
        experience: "",
        hasGraduationDegree: "NO",
        graduationDegrees: [],
        hasPg: "NO",
        pgDegrees: [],
        hasDoctorate: "NO",
        doctorates: [],
        description: "",
    });

    const [showEditJobModal, setShowEditJobModal] = useState(false);

    const [editJobForm, setEditJobForm] = useState({
        id: null,
        title: "",
        industry: "",
        industryId: "",
        industrySubcategory: "",
        location: "",
        function: "",
        functionId: "",
        functionSubcategory: "",
        experience: "",
        hasGraduationDegree: "NO",
        graduationDegrees: [],
        hasPg: "NO",
        pgDegrees: [],
        hasDoctorate: "NO",
        doctorates: [],
        description: "",
    });

    const [showCloseJobModal, setShowCloseJobModal] = useState(false);
    const [selectedJobToClose, setSelectedJobToClose] = useState(null);
    const [listedByLeaderly, setListedByLeaderly] = useState(false);
    const [showJobDetailsModal, setShowJobDetailsModal] = useState(false);
    const [selectedJobDetails, setSelectedJobDetails] = useState(null);
    const [showReopenModal, setShowReopenModal] = useState(false);
    const [selectedJobToReopen, setSelectedJobToReopen] = useState(null);

    const [showReopenSuccessModal, setShowReopenSuccessModal] = useState(false);

    const loadMasterData = async () => {
        try {
            const [
                citiesRes,
                industriesRes,
                functionsRes,
                ugRes,
                pgRes
            ] = await Promise.all([
                MasterDataService.getAllCities(),
                MasterDataService.getAllIndustrySectors(),
                MasterDataService.getAllFunctions(),
                MasterDataService.getAllUgDegrees(),
                MasterDataService.getAllPgDegrees(),
            ]);

            setCities(citiesRes.data);
            setIndustries(industriesRes.data);
            setFunctions(functionsRes.data);
            setUgDegrees(ugRes.data);
            setPgDegrees(pgRes.data);
        } catch (error) {
            console.error(error);
        }
    };
    useEffect(() => {
        loadMasterData();
    }, []);
    const handleIndustryChange = async (event, formSetter) => {
        const selectedId = event.target.value;

        const industry = industries.find(
            item => item.id === Number(selectedId)
        );

        formSetter(prev => ({
            ...prev,
            industryId: selectedId,
            industry: industry?.industrySector || "",
            industrySubcategory: "",
        }));

        const response =
            await MasterDataService.getIndustrySubcategories(selectedId);

        setIndustrySubcategories(response.data);
    };
    const handleFunctionChange = async (event, formSetter) => {
        const selectedId = event.target.value;

        const selectedFunction = functions.find(
            item => item.id === Number(selectedId)
        );

        formSetter(prev => ({
            ...prev,
            functionId: selectedId,
            function: selectedFunction?.function || "",
            functionSubcategory: "",
        }));

        const response =
            await MasterDataService.getFunctionSubcategories(selectedId);

        setFunctionSubcategories(response.data);
    };
    const loadJobs = async (page = 0, status = activeTab) => {
        setLoading(true);

        try {
            const response = await JobListingService.getJobsByStatus(
                status,
                page,
                jobsPerPage
            );

            const data = response.data;
            const formattedJobs = data.jobListings.map((item) => ({
                id: item.id,
                title: item.jobListing.jobTitle,
                function: item.jobListing.function,
                functionSubcategory: item.jobListing.functionSubcategory,
                industry: item.jobListing.industry,
                industrySubcategory: item.jobListing.industrySubcategory,
                location: item.jobListing.location,
                experience: item.jobListing.experience,
                hasGraduationDegree: item.jobListing.hasGraduationDegree || "",
                graduationDegrees: item.jobListing.graduationDegrees || [],
                hasPg: item.jobListing.hasPg || "",
                pgDegrees: item.jobListing.pgDegrees || [],
                hasDoctorate: item.jobListing.hasDoctorate || "",
                doctorates: item.jobListing.doctorates || [],
                description: item.jobListing.jobDescription,
                status: item.status,
                listedByLeaderly: item.listedByLeaderly,
                postedDate: new Date(item.createdDate).toLocaleDateString(
                    "en-GB",
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    }
                ),
            }));

            setJobs(formattedJobs);
            setPageCount(data.pageCount);
            setHasNext(data.hasNext);
            setCurrentPage(data.pageNo);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const loadCounts = async () => {
        try {
            const [activeRes, closedRes] = await Promise.all([
                JobListingService.getJobsByStatus("ACTIVE", 0, 1),
                JobListingService.getJobsByStatus("CLOSED", 0, 1),
            ]);

            setActiveJobsCount(activeRes.data.totalCount);
            setClosedJobsCount(closedRes.data.totalCount);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        loadJobs(currentPage, activeTab);
    }, [currentPage, activeTab]);

    useEffect(() => {
        loadCounts();
    }, []);

    const handleViewJobDetails = (job) => {
        setSelectedJobDetails(job);
        setShowJobDetailsModal(true);
    };

    const handleCloseJobDetailsModal = () => {
        setShowJobDetailsModal(false);
        setSelectedJobDetails(null);
    };

    const displayedJobs = jobs;
    const handleCloseJob = (job) => {
        setSelectedJobToClose(job);
        setShowCloseJobModal(true);
    };

    const handleCancelCloseJob = () => {
        setShowCloseJobModal(false);
        setSelectedJobToClose(null);
        setListedByLeaderly(false);

    };

    const handleConfirmCloseJob = async () => {
        if (!selectedJobToClose) return;
        setLoading(true);
        try {
            await JobListingService.closeJob(
                selectedJobToClose.id,
                listedByLeaderly
            );

            setShowCloseJobModal(false);
            setSelectedJobToClose(null);
            setListedByLeaderly(false);
            loadJobs(currentPage, activeTab);
            loadCounts();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handlePostJob = () => {
        setShowPostJobModal(true);
    };

    const handleClosePostJobModal = () => {
        setShowPostJobModal(false);
        setDoctorateInput("");
        setEditDoctorateInput("");
        setJobForm({
            title: "",
            industry: "",
            industryId: "",
            industrySubcategory: "",
            location: "",
            function: "",
            functionId: "",
            functionSubcategory: "",
            experience: "",
            hasGraduationDegree: "NO",
            graduationDegrees: [],
            hasPg: "NO",
            pgDegrees: [],
            hasDoctorate: "NO",
            doctorates: [],
            description: "",
        });
    };

    const handleJobFormChange = (event) => {
        const { name, value } = event.target;

        setJobForm((prev) => {
            const updated = {
                ...prev,
                [name]: value,
            };

            if (name === "hasGraduationDegree" && value === "NO") {
                updated.graduationDegrees = [];
            }

            if (name === "hasPg" && value === "NO") {
                updated.pgDegrees = [];
            }

            if (name === "hasDoctorate" && value === "NO") {
                updated.doctorates = [];
            }

            return updated;
        });
    };

    const handleSubmitJob = async (event) => {
        event.preventDefault();
        const finalDoctorates =
            jobForm.hasDoctorate === "YES" && doctorateInput.trim()
                ? [...jobForm.doctorates, doctorateInput.trim()]
                : jobForm.doctorates;
        if (
            !jobForm.title.trim() ||
            !jobForm.function.trim() ||
            !jobForm.location.trim() ||
            !jobForm.experience.trim() ||
            !jobForm.description.trim()
        ) {
            alert("Please fill all required fields.");
            return;
        }
        if (
            jobForm.hasGraduationDegree !== "YES" &&
            jobForm.hasPg !== "YES" &&
            jobForm.hasDoctorate !== "YES"
        ) {
            alert("Please select at least one qualification.");
            return;
        }
        if (
            jobForm.hasGraduationDegree === "YES" &&
            jobForm.graduationDegrees.length === 0
        ) {
            alert("Please select at least one Bachelor's degree.");
            return;
        }

        if (
            jobForm.hasPg === "YES" &&
            jobForm.pgDegrees.length === 0
        ) {
            alert("Please select at least one Post Graduation degree.");
            return;
        }

        if (
            jobForm.hasDoctorate === "YES" &&
            finalDoctorates.length === 0
        ) {
            alert("Please enter the Doctorate degree.");
            return;
        }
        setLoading(true);
        const payload = {
            jobListing: {
                jobTitle: jobForm.title,
                industry: jobForm.industry,
                industrySubcategory: jobForm.industrySubcategory,
                function: jobForm.function,
                functionSubcategory: jobForm.functionSubcategory,
                location: jobForm.location,
                experience: jobForm.experience
                    ? Number(jobForm.experience)
                    : null,
                hasGraduationDegree: jobForm.hasGraduationDegree,
                graduationDegrees:
                    jobForm.hasGraduationDegree === "YES"
                        ? jobForm.graduationDegrees
                        : [],

                hasPg: jobForm.hasPg,
                pgDegrees:
                    jobForm.hasPg === "YES"
                        ? jobForm.pgDegrees
                        : [],
                hasDoctorate: jobForm.hasDoctorate,
                doctorates:
                    jobForm.hasDoctorate === "YES"
                        ? finalDoctorates
                        : [],
                jobDescription: jobForm.description,
            },

        };

        try {
            await JobListingService.addJob(payload);

            handleClosePostJobModal();

            loadJobs(0, "ACTIVE");
            loadCounts();

            setCurrentPage(0);
            setActiveTab("ACTIVE");
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleEditJob = async (job) => {
        const selectedIndustry = industries.find(
            item => item.industrySector === job.industry
        );

        const selectedFunction = functions.find(
            item => item.function === job.function
        );

        if (selectedIndustry) {
            const response = await MasterDataService.getIndustrySubcategories(selectedIndustry.id);
            setIndustrySubcategories(response.data);
        }

        if (selectedFunction) {
            const response = await MasterDataService.getFunctionSubcategories(selectedFunction.id);
            setFunctionSubcategories(response.data);
        }

        setEditJobForm({
            id: job.id,
            title: job.title,

            industry: job.industry,
            industryId: selectedIndustry?.id || "",
            industrySubcategory: job.industrySubcategory,

            function: job.function,
            functionId: selectedFunction?.id || "",
            functionSubcategory: job.functionSubcategory,

            location: job.location,
            experience: job.experience,
            hasGraduationDegree: job.hasGraduationDegree || "NO",
            graduationDegrees: job.graduationDegrees || [],
            hasPg: job.hasPg || "NO",
            pgDegrees: job.pgDegrees || [],
            hasDoctorate: job.hasDoctorate || "NO",
            doctorates: job.doctorates || [],
            description: job.description,
        });

        setShowEditJobModal(true);
    };

    const handleCloseEditJobModal = () => {
        setShowEditJobModal(false);
        setDoctorateInput("");
        setEditDoctorateInput("");
        setEditJobForm({
            id: null,
            title: "",
            function: "",
            functionSubcategory: "",
            industry: "",
            industrySubcategory: "",
            location: "",
            experience: "",
            hasGraduationDegree: "NO",
            graduationDegrees: [],
            hasPg: "NO",
            pgDegrees: [],
            hasDoctorate: "NO",
            doctorates: [],
            description: "",
        });
    };

    const handleEditJobFormChange = (event) => {
        const { name, value } = event.target;

        setEditJobForm((previousForm) => {
            const updated = {
                ...previousForm,
                [name]: value,
            };

            if (name === "hasGraduationDegree" && value === "NO") {
                updated.graduationDegrees = [];
            }

            if (name === "hasPg" && value === "NO") {
                updated.pgDegrees = [];
            }

            if (name === "hasDoctorate" && value === "NO") {
                updated.doctorates = [];
            }

            return updated;
        });
    };

    const handleUpdateJob = async (event) => {
        event.preventDefault();
        const finalDoctorates =
            editJobForm.hasDoctorate === "YES" && editDoctorateInput.trim()
                ? [...editJobForm.doctorates, editDoctorateInput.trim()]
                : editJobForm.doctorates;
        if (
            !editJobForm.title.trim() ||
            !editJobForm.function.trim() ||
            !editJobForm.location.trim() ||
            editJobForm.experience === "" ||
            editJobForm.experience === null ||
            editJobForm.experience === undefined ||
            !editJobForm.description.trim()
        ) {
            alert("Please fill all required fields.");
            return;
        }
        if (
            editJobForm.hasGraduationDegree !== "YES" &&
            editJobForm.hasPg !== "YES" &&
            editJobForm.hasDoctorate !== "YES"
        ) {
            alert("Please select at least one qualification.");
            return;
        }
        if (
            editJobForm.hasGraduationDegree === "YES" &&
            editJobForm.graduationDegrees.length === 0
        ) {
            alert("Please select at least one Bachelor's degree.");
            return;
        }

        if (
            editJobForm.hasPg === "YES" &&
            editJobForm.pgDegrees.length === 0
        ) {
            alert("Please select at least one Post Graduation degree.");
            return;
        }

        if (
            editJobForm.hasDoctorate === "YES" &&
            finalDoctorates.length === 0
        ) {
            alert("Please enter the Doctorate degree.");
            return;
        }
        setLoading(true);

        const payload = {
            jobListing: {
                jobTitle: editJobForm.title,
                industry: editJobForm.industry,
                industrySubcategory: editJobForm.industrySubcategory,
                function: editJobForm.function,
                functionSubcategory: editJobForm.functionSubcategory,
                location: editJobForm.location,
                experience: editJobForm.experience
                    ? Number(editJobForm.experience)
                    : null,
                hasGraduationDegree: editJobForm.hasGraduationDegree,
                graduationDegrees:
                    editJobForm.hasGraduationDegree === "YES"
                        ? editJobForm.graduationDegrees
                        : [],

                hasPg: editJobForm.hasPg,
                pgDegrees:
                    editJobForm.hasPg === "YES"
                        ? editJobForm.pgDegrees
                        : [],
                hasDoctorate: editJobForm.hasDoctorate,
                doctorates:
                    editJobForm.hasDoctorate === "YES"
                        ? finalDoctorates
                        : [],
                jobDescription: editJobForm.description,
            },
        };
        try {
            await JobListingService.updateJob(
                editJobForm.id,
                payload
            );

            handleCloseEditJobModal();

            loadJobs(currentPage, activeTab);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleReopenJob = async () => {
        if (!selectedJobToReopen) return;

        setLoading(true);

        try {
            await JobListingService.reopenJob(
                selectedJobToReopen.id
            );

            setShowReopenModal(false);
            setSelectedJobToReopen(null);

            loadJobs(currentPage, activeTab);
            loadCounts();

            setShowReopenSuccessModal(true);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const totalPages = pageCount;

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const current = currentPage + 1;

        if (totalPages <= 5) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            pageNumbers.push(1);

            if (current > 3) {
                pageNumbers.push("...");
            }

            const start = Math.max(2, current - 1);
            const end = Math.min(totalPages - 1, current + 1);

            for (let i = start; i <= end; i++) {
                pageNumbers.push(i);
            }

            if (current < totalPages - 2) {
                pageNumbers.push("...");
            }

            pageNumbers.push(totalPages);
        }

        return pageNumbers;
    };

    return (

        <div className="container mt-5 mb-0 client-job-listings-page">
            {loading && (
                <div className="mycandidates-loader-container">
                    <div className="mycandidates-loader"></div>
                </div>
            )}
            <div className="job-listing-header">
                <div>

                    <h4 className="job-listing-heading">
                        {activeTab === "ACTIVE" ? "Active Jobs" : "Closed Jobs"}
                    </h4>

                    <p className="job-listing-subheading">
                        Manage all the job postings created by your organisation.
                    </p>
                </div>

                <button className="btn post-job-btn" onClick={handlePostJob}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" />
                    Post New Job
                </button>
            </div>

            <div className="job-tabs-wrapper">
                <button
                    className={`job-tab-btn ${activeTab === "ACTIVE" ? "active" : ""}`}
                    onClick={() => {
                        setActiveTab("ACTIVE");
                        setCurrentPage(0);
                    }}
                >
                    Active Jobs
                    <span className="job-count">{activeJobsCount}</span>
                </button>

                <button
                    className={`job-tab-btn ${activeTab === "CLOSED" ? "active" : ""}`}
                    onClick={() => {
                        setActiveTab("CLOSED");
                        setCurrentPage(0);
                    }}
                >
                    Closed Jobs
                    <span className="job-count">{closedJobsCount}</span>
                </button>
            </div>

            {jobs.length > 0 ? (
                <>

                    <div className="row gy-4">
                        {displayedJobs.map((job) => (
                            <div className="col-12 col-md-6 col-lg-4" key={job.id}>
                                <div
                                    className="card h-100 p-4 client-job-card job-details-clickable"
                                    onClick={() => handleViewJobDetails(job)}
                                >
                                    <div className="job-card-top-section">
                                        <div className="job-card-header-left">
                                            <div className="job-icon-box">
                                                <FontAwesomeIcon icon={faBriefcase} />
                                            </div>

                                            <div>
                                                <h5 className="job-title">{job.title}</h5>

                                                <span
                                                    className={`job-status-badge ${job.status === "ACTIVE"
                                                        ? "active-status"
                                                        : "closed-status"
                                                        }`}
                                                >
                                                    {job.status === "ACTIVE" ? "Active" : "Closed"}
                                                </span>
                                            </div>
                                        </div>

                                        <span className="job-posted-date">
                                            Posted: {job.postedDate}
                                        </span>
                                    </div>

                                    <div className="job-meta-details">
                                        <div className="job-meta-item">
                                            <FontAwesomeIcon icon={faLocationDot} />
                                            <span>{job.location}</span>
                                        </div>

                                        <div className="job-meta-item">
                                            <FontAwesomeIcon icon={faBriefcase} />
                                            <span>{job.experience} Yrs</span>
                                        </div>

                                        <div className="job-meta-item">
                                            <FontAwesomeIcon icon={faGraduationCap} />

                                            <span className="job-qualification-preview">
                                                {[
                                                    job.hasGraduationDegree === "YES" &&
                                                    job.graduationDegrees?.length > 0 &&
                                                    `UG: ${job.graduationDegrees.join(", ")}`,

                                                    job.hasPg === "YES" &&
                                                    job.pgDegrees?.length > 0 &&
                                                    `PG: ${job.pgDegrees.join(", ")}`,

                                                    job.hasDoctorate === "YES" &&
                                                    job.doctorates?.length > 0 &&
                                                    `Doctorate: ${job.doctorates.join(", ")}`
                                                ]
                                                    .filter(Boolean)
                                                    .join(" | ") || "-"}
                                            </span>
                                        </div>
                                    </div>

                                    <p className="job-description-preview">{job.description}</p>

                                    {/* <div className="job-card-divider"></div> */}

                                    <div className="job-action-buttons">
                                        {job.status === "ACTIVE" && (
                                            <button
                                                className="btn edit-job-btn"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleEditJob(job);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faPen} className="me-2" />
                                                Edit
                                            </button>
                                        )}

                                        {job.status === "ACTIVE" && (
                                            <button
                                                className="btn close-job-btn"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleCloseJob(job);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faXmark} className="me-2" />
                                                Close Job
                                            </button>
                                        )}

                                        {job.status === "CLOSED" && (
                                            <button
                                                className="btn reopen-job-btn"
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setSelectedJobToReopen(job);
                                                    setShowReopenModal(true);
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faRotateLeft} className="me-2" />
                                                Reopen
                                            </button>

                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {pageCount > 1 && (
                        <div className="d-flex justify-content-center my-4">
                            <div className="pagination-container">
                                <button
                                    onClick={() => setCurrentPage(0)}
                                    disabled={currentPage === 0}
                                >
                                    {"<<"}
                                </button>

                                <button
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                    disabled={currentPage === 0}
                                >
                                    {"<"}
                                </button>

                                {renderPageNumbers().map((page, index) => (
                                    <button
                                        key={index}
                                        className={currentPage + 1 === page ? "active" : ""}
                                        onClick={() => {
                                            if (typeof page === "number") {
                                                setCurrentPage(page - 1);
                                            }
                                        }}
                                        disabled={typeof page !== "number"}
                                    >
                                        {page}
                                    </button>
                                ))}

                                <button
                                    onClick={() => setCurrentPage((prev) => prev + 1)}
                                    disabled={!hasNext}
                                >
                                    {">"}
                                </button>

                                <button
                                    onClick={() => setCurrentPage(pageCount - 1)}
                                    disabled={!hasNext}                                >
                                    {">>"}
                                </button>
                            </div>
                        </div>
                    )}

                </>

            ) : (
                <div className="no-jobs-container">
                    <FontAwesomeIcon icon={faBriefcase} className="no-jobs-icon" />

                    <h5>No {activeTab === "ACTIVE" ? "active" : "closed"} jobs found</h5>

                    <p>
                        {activeTab === "ACTIVE"
                            ? "Click on Post New Job to create a job posting."
                            : "Closed job postings will appear here."}
                    </p>
                </div>
            )}
            <JobFormModal
                show={showPostJobModal}
                title="Post New Job"
                buttonText="Post Job"
                loading={loading}
                form={jobForm}
                onClose={handleClosePostJobModal}
                onSubmit={handleSubmitJob}
                onChange={handleJobFormChange}
                cities={cities}
                industries={industries}
                industrySubcategories={industrySubcategories}
                functions={functions}
                functionSubcategories={functionSubcategories}
                ugDegrees={ugDegrees}
                pgDegrees={pgDegrees}
                doctorateInput={doctorateInput}
                setDoctorateInput={setDoctorateInput}
                onIndustryChange={(e) => handleIndustryChange(e, setJobForm)}
                onFunctionChange={(e) => handleFunctionChange(e, setJobForm)}
            />
            <JobFormModal
                show={showEditJobModal}
                title="Edit Job"
                buttonText="Update Job"
                loading={loading}
                form={editJobForm}
                onClose={handleCloseEditJobModal}
                onSubmit={handleUpdateJob}
                onChange={handleEditJobFormChange}
                cities={cities}
                industries={industries}
                industrySubcategories={industrySubcategories}
                functions={functions}
                functionSubcategories={functionSubcategories}
                ugDegrees={ugDegrees}
                pgDegrees={pgDegrees}
                doctorateInput={editDoctorateInput}
                setDoctorateInput={setEditDoctorateInput}
                onIndustryChange={(e) => handleIndustryChange(e, setEditJobForm)}
                onFunctionChange={(e) => handleFunctionChange(e, setEditJobForm)}
            />
            <Modal
                show={showCloseJobModal}
                onHide={handleCancelCloseJob}
                centered
                className="close-job-confirmation-modal"
            >
                <Modal.Header closeButton className="close-job-modal-header">
                    {/* <Modal.Title className="close-job-modal-title">
                        Close Job
                    </Modal.Title> */}
                </Modal.Header>

                <Modal.Body className="close-job-modal-body">
                    <h5 className="close-job-confirmation-heading">
                        Do you want to close this job?
                    </h5>

                    <p className="close-job-confirmation-text">
                        The job posting
                        <span className="close-job-name">
                            {" "}{selectedJobToClose?.title}
                        </span>
                        {" "}will no longer be visible to candidates.
                    </p>

                    <Form.Group className="mt-4 text-center">
                        <Form.Label className="fw-semibold">
                            Did you hire a candidate from Leaderly?
                        </Form.Label>

                        <div className="mt-2">
                            <Form.Check
                                inline
                                type="radio"
                                id="leaderlyYes"
                                label="Yes"
                                name="listedByLeaderly"
                                checked={listedByLeaderly === true}
                                onChange={() => setListedByLeaderly(true)}
                            />

                            <Form.Check
                                inline
                                type="radio"
                                id="leaderlyNo"
                                label="No"
                                name="listedByLeaderly"
                                checked={listedByLeaderly === false}
                                onChange={() => setListedByLeaderly(false)}
                            />
                        </div>
                    </Form.Group>
                </Modal.Body>

                <Modal.Footer className="close-job-modal-footer">
                    <button
                        type="button"
                        className="btn cancel-job-btn"
                        onClick={handleCancelCloseJob}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn confirm-close-job-btn"
                        onClick={handleConfirmCloseJob}
                        disabled={loading}
                    >
                        {loading ? "Closing..." : "Yes, Close Job"}
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showJobDetailsModal}
                onHide={handleCloseJobDetailsModal}
                centered
                className="job-details-modal"
            >
                <Modal.Header closeButton className="post-job-modal-header">
                    <Modal.Title className="post-job-modal-title">
                        Job Details
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="job-details-scroll-body">

                    <div className="job-details-header">

                        <div className="job-details-header-left">
                            <div className="job-details-icon-box">
                                <FontAwesomeIcon icon={faBriefcase} />
                            </div>

                            <div>
                                <h4 className="job-details-title">
                                    {selectedJobDetails?.title}
                                </h4>

                                <p className="job-details-posted-date">
                                    Posted on {selectedJobDetails?.postedDate}
                                </p>
                            </div>
                        </div>

                        <span
                            className={`job-status-badge ${selectedJobDetails?.status === "ACTIVE"
                                ? "active-status"
                                : "closed-status"
                                }`}
                        >
                            {selectedJobDetails?.status === "ACTIVE"
                                ? "Active"
                                : "Closed"}
                        </span>

                    </div>

                    <div className="job-details-divider"></div>

                    <div className="job-meta-details">
                        <div className="job-meta-item">
                            <FontAwesomeIcon icon={faLocationDot} />
                            {selectedJobDetails?.location}
                        </div>

                        <div className="job-meta-item">
                            <FontAwesomeIcon icon={faBriefcase} />
                            {selectedJobDetails?.experience} Years
                        </div>

                        <div className="job-meta-item">
                            <FontAwesomeIcon icon={faGraduationCap} />

                            <div>
                                {selectedJobDetails?.hasGraduationDegree === "YES" && (
                                    <div>
                                        <strong>UG:</strong>{" "}
                                        {selectedJobDetails.graduationDegrees?.join(", ")}
                                    </div>
                                )}

                                {selectedJobDetails?.hasPg === "YES" && (
                                    <div>
                                        <strong>PG:</strong>{" "}
                                        {selectedJobDetails.pgDegrees?.join(", ")}
                                    </div>
                                )}

                                {selectedJobDetails?.hasDoctorate === "YES" && (
                                    <div>
                                        <strong>Doctorate:</strong>{" "}
                                        {selectedJobDetails.doctorates?.join(", ")}
                                    </div>
                                )}

                                {selectedJobDetails?.hasGraduationDegree !== "YES" &&
                                    selectedJobDetails?.hasPg !== "YES" &&
                                    selectedJobDetails?.hasDoctorate !== "YES" && (
                                        <span>-</span>
                                    )}
                            </div>
                        </div>
                    </div>

                    {selectedJobDetails?.industry && (
                        <>
                            <h6 className="job-details-label mt-3">Industry</h6>
                            <p className="job-details-description">
                                {selectedJobDetails.industry}
                                {selectedJobDetails.industrySubcategory &&
                                    ` • ${selectedJobDetails.industrySubcategory}`}
                            </p>
                        </>
                    )}

                    {selectedJobDetails?.function && (
                        <>
                            <h6 className="job-details-label mt-3">Function</h6>
                            <p className="job-details-description">
                                {selectedJobDetails.function}
                                {selectedJobDetails.functionSubcategory &&
                                    ` • ${selectedJobDetails.functionSubcategory}`}
                            </p>
                        </>
                    )}
                    <div className="job-details-divider"></div>

                    <h6 className="job-details-label">
                        Job Description
                    </h6>

                    <p className="job-details-description">
                        {selectedJobDetails?.description}
                    </p>

                </Modal.Body>

                <Modal.Footer className="post-job-modal-footer">
                    <button
                        type="button"
                        className="btn cancel-job-btn"
                        onClick={handleCloseJobDetailsModal}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showReopenModal}
                onHide={() => {
                    setShowReopenModal(false);
                    setSelectedJobToReopen(null);
                }}
                centered
                className="close-job-confirmation-modal"
            >
                <Modal.Header closeButton className="close-job-modal-header">
                    {/* <Modal.Title className="close-job-modal-title">
                        Reopen Job
                    </Modal.Title> */}
                </Modal.Header>

                <Modal.Body className="close-job-modal-body">
                    <h5 className="close-job-confirmation-heading">

                        Do you want to reopen this job?
                    </h5>
                </Modal.Body>

                <Modal.Footer className="close-job-modal-footer">
                    <button
                        type="button"
                        className="btn cancel-job-btn"
                        onClick={() => {
                            setShowReopenModal(false);
                            setSelectedJobToReopen(null);
                        }}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        className="btn confirm-close-job-btn"

                        onClick={handleReopenJob}
                        disabled={loading}
                    >
                        {loading ? "Reopening..." : "Yes"}
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showReopenSuccessModal}
                onHide={() => setShowReopenSuccessModal(false)}
                centered
            >
                <Modal.Header closeButton className="close-job-reopen-header">
                    <Modal.Title>Job Reopened</Modal.Title>
                </Modal.Header>

                <Modal.Body className="close-job-reopen-body">
                    The selected job has been reopened as a new job.
                    <br />
                    Please check <strong>Active Jobs</strong>.
                </Modal.Body>

                <Modal.Footer className="close-job-modal-footer">
                    <button
                        type="button"
                        className="btn cancel-job-btn"
                        onClick={() => setShowReopenSuccessModal(false)}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ClientJobListings;
